// extracted by mini-css-extract-plugin
export default {"sticky":"TableWidget_sticky__1Hzyc","card":"TableWidget_card__DcVxq","table":"TableWidget_table__aQ2CK","col":"TableWidget_col__9hl+S"};